import React, { useEffect, useState } from "react";
import Button from "../../../components/button";

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import TextInputField from "../../../components/textInput";
import Select from "../../../components/select";
import Checkbox from "../../../components/checkbox";
import API from "../../../api";
import { RefreshCw, Trash, PlusSquare } from "react-feather";
import Swal from "sweetalert2";
import { ChromePicker } from "react-color";

import UploadableImages from "../../../libraries/uploadableImages";
import Builder from "./builder";
import Util from "./util";
import { useLanguage } from '@languages/index';



interface Props {
  review?: any;
  onSetPublishState: any;
  onEditClick: any;
  onBsProductUrlChanged: any;

  auth?: any;
  showModal?: any;
  closeModal?: any;
}

const RightSideOfDetail = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  if (!props.review)
    return null;


  return (
      <div className="flex flex-col justify-start grow ml-[50px]">
        <div className="flex flex-row justify-start items-center w-full">

          {/* publish and edit */}
          <div className="w-[96px] h-[40px]">
            <Button
                className="py-0 h-full flex justify-center items-center"
                borderColor={props.review.isPublished ? "#000000" : "#E8E8E8"}
                buttonColor={props.review.isPublished ? "#000000" : "WHITE"}
                textColor={props.review.isPublished ? "WHITE" : "BLACK"}
                text={languageTexts.public}
                textClassName={"text-[14px]"}
                onClick={() => props.onSetPublishState(true)}
            />
          </div>
          <div className="w-[96px] h-[40px]">
            <Button
                className="py-0 h-full flex justify-center items-center"
                buttonColor={props.review.isPublished ? "WHITE" : "#E8E8E8"}
                borderColor={props.review.isPublished ? "#E8E8E8" : "#E8E8E8"}
                text={languageTexts.private}
                textClassName={"text-[14px]"}
                onClick={() => props.onSetPublishState(false)}
            />
          </div>
          <span className="grow" />
          {(props.onEditClick == null)? null:
              <span
                  className="text-[14px] text-[#000000] underline cursor-pointer"
                  onClick={(e)=>props.onEditClick()}
              >
                {languageTexts.celeb_detail_text_7}
              </span>
          }
        </div>


        {/* publish and edit */}
        <span className="mt-[40px] mb-[14px] font-bold text-[22px] text-[#000000]">
          {languageTexts.celeb_detail_text_8}
        </span>

        {props.review.products.map((product) => (
          <div key={product.id} className="mb-[15px] flex flex-row justify-start items-center">
            <img
              className="mr-[18px] w-[77px] h-[77px] object-cover"
              src={Util.makeImageUrl("brand_sns/thumb-sm", product.imageUrl)}
              alt={product.name}
            />

            <div className="flex flex-col grow overflow-hidden">
              <span className="font-bold text-[15px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                {product.name}
              </span>

              <span
                className="mt-[5px] text-black text-[15px] font-normal"
                style={{ wordBreak: "keep-all" }}
              >
                {languageTexts._wear(product.sizeName)}
              </span>

              <div className="mt-[5px] flex flex-row justify-between">
                <a
                  className="cursor-pointer text-[15px] text-[#0066FF] underline whitespace-nowrap truncate text-ellipsis overflow-hidden max-w-[350px]"
                  onClick={() => {
                    Util.onLinkClick(product.url);
                  }}
                >
                  {`${Util.getUrlText(product.url)}`}
                </a>

                <span
                  className="underline text-[15px] text-[#999999] cursor-pointer hover:text-black"
                  onClick={() => {
                    Util.showBsProductUrlEditModal(
                        props,
                        product.bsProductId,
                        (res) => {
                          props.onBsProductUrlChanged(res);
                        },
                        languageTexts.right_side_text_1,
                        languageTexts.right_side_text_2
                    );
                  }}
                >
                  {languageTexts.change2}
                </span>
              </div>
            </div>
          </div>
       ))}

      </div>
  );
}

export default connect(mapStateToProps, mapDispatchProps)(RightSideOfDetail);




